import { Grid, makeStyles, useMediaQuery } from '@material-ui/core'
import ProfilePicture from 'components/common/ProfilePicture'
import DazzedHeading18 from 'components/common/text/DazzedHeading18'
import Tooltip from 'components/common/Tooltip'
import React from 'react'
import { useTranslation } from 'react-i18next'
import TagsList from '../../common/tags/TagsList'
import PatientDemographic from './PatientDemographic'
import PatientHeaderPresenceMarker from './PatientHeaderPresenceMarker'
import TagsSkeleton from './TagsSkeleton'

const useStyles = makeStyles({
  container: {
    paddingLeft: 10
  },
  avatar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0 20px',
    '@media (max-width:1200px)': {
      padding: '0 12px'
    }
  },
  avatarHidden: {
    display: 'none'
  },
  patientName: {
    lineHeight: '32px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px'
  },
  patientNameText: {
    whiteSpace: 'nowrap',
    maxWidth: ({ isExtraSmallScreen }) => (isExtraSmallScreen ? '270px' : '350px'),
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    maxWidth: '85%'
  },
  tooltip: {
    background: 'var(--bg-color-12)'
  },
  arrowTooltip: {
    color: 'var(--bg-color-12)'
  }
})

const PatientsDetails = ({
  patient,
  handleOpenPatientCard,
  tags,
  canDeleteNeedsAttention,
  handleDeleteTag,
  permissions,
  isLoading = false
}) => {
  const { t } = useTranslation()
  const isExtraSmallScreen = useMediaQuery('(max-width:1490px)')
  const isNarrowScreen = useMediaQuery('(max-width:1200px)')
  const isVeryNarrowScreen = useMediaQuery('(max-width:1100px)')
  const classes = useStyles({ isExtraSmallScreen })

  return (
    <Grid container className={classes.container}>
      <Grid
        item
        id="patient-room-header-patient-card-button"
        className={classes.avatar}
        onClick={handleOpenPatientCard}
      >
        <Tooltip
          arrow
          value={t('pages.patients.selectedPatient.header.patientCardTooltip')}
          placement="bottom"
          classes={{ arrow: classes.arrowTooltip, tooltip: classes.tooltip }}
        >
          <ProfilePicture
            size={isVeryNarrowScreen ? 'xsmall' : isNarrowScreen ? 'small' : 'large'}
            photo={patient.photo}
            name={patient.details.name}
            email={patient.details.email}
          />
        </Tooltip>
      </Grid>
      <Grid className={classes.item}>
        <Grid container direction="column">
          <Grid item>
            <DazzedHeading18>
              <div className={classes.patientName}>
                <span
                  id="patient-room-header-patient-name"
                  onClick={handleOpenPatientCard}
                  className={classes.patientNameText}
                >
                  {patient?.details?.name}
                </span>
                <PatientDemographic patient={patient} />
                <PatientHeaderPresenceMarker patientId={patient?.id} />
              </div>
            </DazzedHeading18>
          </Grid>
          <Grid item>
            {isLoading ? (
              <TagsSkeleton numberOfTags={2} />
            ) : (
              <TagsList
                tags={tags}
                onDeleteTag={handleDeleteTag}
                canDeleteCustom={permissions.editPatientTags}
                canDeleteNeedsAttention={canDeleteNeedsAttention}
                canDeleteScan={false}
                showIcon={permissions.editPatientTags}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PatientsDetails
